module.exports = __webpack_public_path__ + "./static/img/about_big.2fd1941b6edef8509db4361ac5b0f649.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/about_big.png
// module id = ./client/src/assets/fontawesome/about_big.png
// module chunks = 0